// TODO - ORD-80 remove this index file
import { payment } from './payment';
import { store } from './store';
import { user } from './user';
import { whitelabel } from './whitelabel';

export const endpoints = { payment, store, user, whitelabel };
